/**
 * 문자열을 Title Case로 변환
 * camelCase, PascalCase, snake_case, kebab-case 모두 지원
 *
 * @example
 * toTitleCase("full_outfit")  // "Full Outfit"
 * toTitleCase("fullOutfit")   // "Full Outfit"
 * toTitleCase("full-outfit")  // "Full Outfit"
 * toTitleCase("FullOutfit")   // "Full Outfit"
 * toTitleCase(123)            // "123"
 */
export function toTitleCase(value: string | number): string {
	return String(value)
		.replace(/([a-z])([A-Z])/g, "$1 $2")
		.replace(/[_-]/g, " ")
		.toLowerCase()
		.replace(/\b\w/g, (c) => c.toUpperCase())
}
